import { Link } from "gatsby"
import React from "react"
import styled from '@emotion/styled'

import Logo from './LogoWhite'
import Navigation from './Navigation'
import Section from './Section'
import SectionContent from './SectionContent'
import ContactImage from './ContactImage'
import Contact from './Contact'
import AnchorBecauseSticky from './AnchorBecauseSticky'

const Container = styled.footer`
  background: #1b1b1b;
  padding: 1rem 0;
  margin: auto;
  width: 100%;
`

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 960px;
  margin: auto;
`

const LogoContainer = styled.div`
  margin: 2rem 0 0.5rem 0;
`

const SocialMedia = styled.div`
  padding: 4rem;
`

const Footer = () => (
  <>
    <AnchorBecauseSticky id="reach-out" />
    <Section title="Enquire within">
      <SectionContent>
        <Contact style={{flex: 1, marginRight: '2rem'}} />
        <ContactImage style={{flex: 1.5}} />
      </SectionContent>
    </Section>
  <Container>
    <ContentContainer>
      <LogoContainer>
        <Logo />
      </LogoContainer>
      <Navigation color="#fff" />
      <SocialMedia />
    </ContentContainer>
  </Container>
  </>
)

export default Footer
